/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type TypeOfMessageable = "happening" | "message" | "offer" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageCell_message$ref: FragmentReference;
declare export opaque type MessageCell_message$fragmentType: MessageCell_message$ref;
export type MessageCell_message = {|
  +id: string,
  +title: ?string,
  +body: ?string,
  +endDate: ?any,
  +messageableType: TypeOfMessageable,
  +messageDisplay: ?{|
    +title: string,
    +body: string,
    +endDate: any,
  |},
  +$refType: MessageCell_message$ref,
|};
export type MessageCell_message$data = MessageCell_message;
export type MessageCell_message$key = {
  +$data?: MessageCell_message$data,
  +$fragmentRefs: MessageCell_message$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageCell_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageableType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDisplay",
      "kind": "LinkedField",
      "name": "messageDisplay",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Message"
};
})();
// prettier-ignore
(node/*: any*/).hash = '730ea167ccc4d0934dd5be7a8194e356';

module.exports = node;
